import { render, staticRenderFns } from "./order_send_guide.vue?vue&type=template&id=4ead07e0&scoped=true"
import script from "./order_send_guide.vue?vue&type=script&lang=js"
export * from "./order_send_guide.vue?vue&type=script&lang=js"
import style0 from "./order_send_guide.vue?vue&type=style&index=0&id=4ead07e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ead07e0",
  null
  
)

export default component.exports